document.addEventListener('DOMContentLoaded', function () {
    const shapeInputsMap = {
        rectangle: ['Length', 'Width', 'Height'],
        cube: ['Side Length'],
        hexagon: ['Length', 'Width', 'Height', 'Front Pane'],
        octagon: ['Length', 'Width', 'Height', 'Front Pane', 'End Pane'],
        flatBackHexagon: ['Length', 'Width', 'Height', 'Front Pane', 'End Pane'],
        cylinder: ['Radius', 'Height'],
        halfCylinder: ['Radius', 'Height'],
        cornerCylinder: ['Radius', 'Height'],
        elliptical: ['Radius 1', 'Radius 2', 'Height'],
        cornerPentagon: ['Length Long Side', 'Length Short Side', 'Height'],
        lShaped: ['Length 1', 'Width 1', 'Length 2', 'Width 2', 'Height'],
        cornerPrism: ['Length 1', 'Length 2', 'Height']
    };

    const sandTypes = {
        fijiPink: { imperial: 90, metric: 1440 },
        specialGrade: { imperial: 85, metric: 1362 },
        bahamasOolite: { imperial: 96, metric: 1537 },
        indoPacificBlack: { imperial: 90, metric: 1441 },
        westCaribbeanReef: { imperial: 90, metric: 1442 },
        hawaiianBlack: { imperial: 55, metric: 877 },
        biminiPink: { imperial: 90, metric: 1440 },
        naturalReef: { imperial: 85, metric: 1362 },
        floridaCrushedCoral: { imperial: 90, metric: 1442 },
        // Added substrate materials. Sand densities above are unchanged.
        aragoniteSand: { imperial: 96, metric: 1538 },
        aquariumGravel: { imperial: 100, metric: 1602 },
        coarseGravel: { imperial: 105, metric: 1682 }
    };

    const shapeImages = {
        rectangle: 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-RectangleFull.jpg?v=1747672321',
        cube: 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-CubeFull.jpg?v=1747672321',
        hexagon: 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-HexagonFull.jpg?v=1747672321',
        octagon: 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-OctogonFull.jpg?v=1747672321',
        flatBackHexagon: 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-FlatBackHexagonFull.jpg?v=1747672321',
        cylinder: 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-CylinderFull.jpg?v=1747672321',
        halfCylinder: 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-HalfCylinderFull.jpg?v=1747672321',
        cornerCylinder: 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-CornerCylinderFull.jpg?v=1747673515',
        elliptical: 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-EllipticalFull.jpg?v=1747672321',
        cornerPentagon: 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-CornerPentagonFull.jpg?v=1747672321',
        lShaped: 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-LShapedFull.jpg?v=1747672321',
        cornerPrism: 'https://cdn.shopify.com/s/files/1/0783/0873/7322/files/CalcIcon-CornerPrismFull.jpg?v=1747672321'
    };

    const shapeNames = {
        rectangle: 'Rectangle',
        cube: 'Cube',
        hexagon: 'Hexagon',
        octagon: 'Octagon',
        flatBackHexagon: 'Flat Back Hexagon',
        cylinder: 'Cylinder',
        halfCylinder: 'Half Cylinder',
        cornerCylinder: 'Corner Cylinder',
        elliptical: 'Elliptical',
        cornerPentagon: 'Corner Pentagon',
        lShaped: 'L-Shaped',
        cornerPrism: 'Corner Prism'
    };

    const unitToggle = document.getElementById('unitToggle');
    const customDropdown = document.getElementById('customDropdown');
    const dropdownText = document.getElementById('dropdownText');
    const shapeMiniIcons = document.getElementById('shapeMiniIcons');
    const selectedShapeImage = document.getElementById('selectedShapeImage');
    const sandDepthInput = document.getElementById('sandDepth');
    const sandTypeSelect = document.getElementById('sandType');
    const sandBedResultDiv = document.getElementById('sandBedResult');
    const inputsDiv = document.getElementById('inputs');
    const unitText = document.querySelector('.unit-text');

    if (
        !unitToggle ||
        !customDropdown ||
        !dropdownText ||
        !shapeMiniIcons ||
        !selectedShapeImage ||
        !sandDepthInput ||
        !sandTypeSelect ||
        !sandBedResultDiv ||
        !inputsDiv
    ) {
        console.error('Required DOM elements not found for Sand Bed Calculator');
        return;
    }

    let currentUnit = 'imperial';
    let selectedShape = 'rectangle';

    function sanitizeId(label) {
        return label.toLowerCase().replace(/\s+/g, '_');
    }

    function getCurrentUnit() {
        return unitToggle.checked ? 'metric' : 'imperial';
    }

    function getUnitShortLabel(unit) {
        return unit === 'imperial' ? 'in' : 'cm';
    }

    function convertValue(value, fromUnit, toUnit) {
        if (value === null || value === '' || Number.isNaN(Number(value))) {
            return '';
        }

        const parsed = parseFloat(value);

        if (fromUnit === toUnit) {
            return parsed;
        }

        return fromUnit === 'imperial'
            ? (parsed * 2.54).toFixed(2)
            : (parsed / 2.54).toFixed(2);
    }

    function updateShapeImage() {
        const img = selectedShapeImage.querySelector('img');
        if (!img) return;

        img.src = shapeImages[selectedShape] + '&width=480';
        img.alt = `Selected shape: ${shapeNames[selectedShape]}`;
    }

    function updateShapeSelectDisplay() {
        dropdownText.textContent = shapeNames[selectedShape];
    }

    function updateActiveShapeOption() {
        const options = shapeMiniIcons.querySelectorAll('.shape-mini-option');
        options.forEach((option) => {
            option.classList.toggle('active', option.dataset.shape === selectedShape);
        });
    }

    function closeShapeMenu() {
        shapeMiniIcons.classList.remove('active');
        customDropdown.setAttribute('aria-expanded', 'false');
    }

    function toggleShapeMenu() {
        const willOpen = !shapeMiniIcons.classList.contains('active');
        shapeMiniIcons.classList.toggle('active', willOpen);
        customDropdown.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    }

    function renderInputs() {
        const existingValues = {};
        inputsDiv.querySelectorAll('input').forEach((input) => {
            existingValues[input.id] = input.value;
        });

        inputsDiv.innerHTML = '';
        inputsDiv.classList.add('input-grid');

        const unit = getCurrentUnit();
        const unitLabel = getUnitShortLabel(unit);
        const fields = shapeInputsMap[selectedShape];

        fields.forEach((labelText) => {
            const id = sanitizeId(labelText);

            const wrapper = document.createElement('div');
            wrapper.className = 'input-field';

            const label = document.createElement('label');
            label.setAttribute('for', id);
            label.textContent = `${labelText} (${unitLabel})`;

            const input = document.createElement('input');
            input.type = 'number';
            input.id = id;
            input.min = '0';
            input.step = '0.1';
            input.placeholder = `Enter ${labelText.toLowerCase()}`;
            input.setAttribute('aria-label', `Enter ${labelText.toLowerCase()} in ${unitLabel}`);
            input.value = existingValues[id] || '';
            input.addEventListener('input', calculateSandBed);

            wrapper.appendChild(label);
            wrapper.appendChild(input);
            inputsDiv.appendChild(wrapper);
        });
    }

    function getInputValues() {
        const values = {};

        shapeInputsMap[selectedShape].forEach((label) => {
            const id = sanitizeId(label);
            const element = document.getElementById(id);
            values[id] = element && element.value ? parseFloat(element.value) : null;
        });

        return values;
    }

    function calculateBaseArea(shape, inputs) {
        switch (shape) {
            case 'rectangle':
                if (!inputs.length || !inputs.width) return null;
                return inputs.length * inputs.width;

            case 'cube':
                if (!inputs.side_length) return null;
                return inputs.side_length * inputs.side_length;

            case 'cylinder':
                if (!inputs.radius) return null;
                return Math.PI * inputs.radius * inputs.radius;

            case 'halfCylinder':
                if (!inputs.radius) return null;
                return (Math.PI * inputs.radius * inputs.radius) / 2;

            case 'cornerCylinder':
                if (!inputs.radius) return null;
                return (Math.PI * inputs.radius * inputs.radius) / 4;

            case 'hexagon':
                if (!inputs.length || !inputs.width) return null;
                if (inputs.front_pane && inputs.front_pane <= inputs.width) {
                    const side = inputs.front_pane;
                    return (3 * Math.sqrt(3) / 2) * (side * side);
                }
                return inputs.length * inputs.width;

            case 'octagon':
                if (!inputs.length || !inputs.width) return null;
                return inputs.length * inputs.width;

            case 'flatBackHexagon':
                if (!inputs.length || !inputs.width) return null;
                if (
                    inputs.front_pane &&
                    inputs.end_pane &&
                    inputs.front_pane <= inputs.width &&
                    inputs.end_pane <= inputs.width
                ) {
                    return inputs.length * inputs.width;
                }
                return inputs.length * inputs.width * 0.824;

            case 'elliptical':
                if (!inputs.radius_1 || !inputs.radius_2) return null;
                return Math.PI * inputs.radius_1 * inputs.radius_2;

            case 'cornerPentagon':
                if (!inputs.length_long_side || !inputs.length_short_side) return null;
                return inputs.length_long_side * inputs.length_short_side;

            case 'lShaped':
                if (!inputs.length_1 || !inputs.width_1 || !inputs.length_2 || !inputs.width_2) return null;
                return (
                    (inputs.length_1 * inputs.width_1) +
                    (inputs.length_2 * inputs.width_2) -
                    (Math.min(inputs.width_1, inputs.length_2) * Math.min(inputs.length_1, inputs.width_2))
                );

            case 'cornerPrism':
                if (!inputs.length_1 || !inputs.length_2) return null;
                return (inputs.length_1 * inputs.length_2) / 2;

            default:
                return null;
        }
    }

    function calculateSandBed() {
        const unit = getCurrentUnit();
        const inputs = getInputValues();
        const sandDepth = sandDepthInput.value ? parseFloat(sandDepthInput.value) : null;
        const sandType = sandTypeSelect.value;
        const baseArea = calculateBaseArea(selectedShape, inputs);

        if (!baseArea || !sandDepth || sandDepth <= 0 || !sandTypes[sandType]) {
            sandBedResultDiv.textContent = 'Enter your tank details';
            return;
        }

        let sandVolume;
        let sandWeight;
        let resultUnit;

        if (unit === 'imperial') {
            sandVolume = (baseArea * sandDepth) / 1728;
            sandWeight = sandVolume * sandTypes[sandType].imperial;
            resultUnit = 'pounds';
        } else {
            sandVolume = (baseArea * sandDepth) / 1000000;
            sandWeight = sandVolume * sandTypes[sandType].metric;
            resultUnit = 'kilograms';
        }

        sandBedResultDiv.textContent = `${sandWeight.toFixed(2)} ${resultUnit}`;
    }

    function updateUnitLabel() {
        const previousUnit = currentUnit;
        currentUnit = getCurrentUnit();

        if (unitText) {
            unitText.textContent = `(${getUnitShortLabel(currentUnit)})`;
        }

        inputsDiv.querySelectorAll('input').forEach((input) => {
            if (input.value) {
                input.value = convertValue(input.value, previousUnit, currentUnit);
            }
        });

        if (sandDepthInput.value) {
            sandDepthInput.value = convertValue(sandDepthInput.value, previousUnit, currentUnit);
        }

        renderInputs();
        calculateSandBed();
    }

    customDropdown.addEventListener('click', function (event) {
        event.stopPropagation();
        toggleShapeMenu();
    });

    document.addEventListener('click', function (event) {
        if (!customDropdown.contains(event.target) && !shapeMiniIcons.contains(event.target)) {
            closeShapeMenu();
        }
    });

    shapeMiniIcons.addEventListener('click', function (event) {
        const option = event.target.closest('.shape-mini-option');
        if (!option) return;

        selectedShape = option.dataset.shape;
        updateShapeImage();
        updateShapeSelectDisplay();
        updateActiveShapeOption();
        renderInputs();
        calculateSandBed();
        closeShapeMenu();
    });

    unitToggle.addEventListener('change', updateUnitLabel);
    sandDepthInput.addEventListener('input', calculateSandBed);
    sandTypeSelect.addEventListener('change', calculateSandBed);

    updateShapeImage();
    updateShapeSelectDisplay();
    updateActiveShapeOption();
    renderInputs();
    calculateSandBed();
});